import React, { useEffect, useState } from "react";
import './MonitorFatiga.scss'
import { getFatigueMonitor } from "./integracion";
import CardsPanel from "./Partes/CardsPanel/CardsPanel";
import Graficas from "./Partes/Graficas/Graficas";
import TableMF from "./Partes/TableMF/TableMF";
import SidePanel from "../../../components/organismsv2/SidePanel/SidePanel";
import Button from "../../../components/Atomsv2/Button/Button";
import Text from "../../../components/Atomsv2/Text/Text";


const CAMPOS = [
    {
        campo: "ID",
        icon: "badge",
        descripcion: "Identificador único y clave primaria del operador en el sistema.",
        calculo: "TR_CHOFER.ID",
    },
    {
        campo: "NOMBRE",
        icon: "person",
        descripcion: "Nombre completo del elemento en activo.",
        calculo: "TR_CHOFER.NOMBRE",
    },
    {
        campo: "DIAS_LABORADOS",
        icon: "calendar_month",
        descripcion: "Días calendario distintos en los que el operador concluyó al menos un servicio exitosamente durante la ventana de 14 días.",
        calculo: "COUNT(DISTINCT B.FECHA) — los turnos nocturnos que cruzan la medianoche pueden arrojar hasta 15 días.",
    },
    {
        campo: "TOTAL_VIAJES",
        icon: "route",
        descripcion: "Volumen bruto de la carga de trabajo del operador en el periodo.",
        calculo: "COUNT(B.ID_CHOFER) — excluye viajes no confirmados, cancelados o con cierres faltantes.",
    },
    {
        campo: "DESC_PROM_NOCTURNO",
        icon: "bedtime",
        descripcion: "Media estadística en horas del tiempo de recuperación principal del operador entre jornadas.",
        calculo: "AVG(bloque_descanso_diario_más_largo) por jornada dentro del periodo.",
    },
    {
        campo: "MINIMO_DESC_NOCTURNO",
        icon: "warning",
        descripcion: "Indicador de vulnerabilidad crítica: el bloque de descanso más corto de toda la catorcena. Expone el día de mayor riesgo de fatiga aguda.",
        calculo: "DATEDIFF(LAG analítico) → filtro ≥ 3 h → MAX por día → MIN de esos máximos.",
        critical: true,
    },
    {
        campo: "FECHA_ULTIMO_DESCANSO",
        icon: "event_available",
        descripcion: "Fecha del último descanso prolongado del operador. Si está vacío, no hubo desconexión ≥ 20 h en las últimas dos semanas.",
        calculo: "MAX(CAST(HORA_FIN_ANTERIOR AS DATE)) donde GAP_HORAS >= 20.",
    },
    {
        campo: "CLIENTE_PRINCIPAL",
        icon: "business",
        descripcion: "Empresa que absorbe la mayor demanda de tiempo y asignaciones del operador en el periodo.",
        calculo: "ROW_NUMBER() OVER(PARTITION BY ID_CHOFER ORDER BY COUNT(*) DESC) = 1.",
    },
    {
        campo: "NIVEL_FATIGA",
        icon: "monitor_heart",
        descripcion: "Clasificador automatizado de riesgo operativo para Talento Humano y Operaciones.",
        calculo: null,
        niveles: [
            { color: "high",   emoji: "🔴", label: "RIESGO ALTO — Fatiga Extrema",    desc: "Promedio de descanso nocturno < 6 h  O  más de 14 días consecutivos sin descanso prolongado (≥ 20 h)." },
            { color: "medium", emoji: "🟡", label: "RIESGO MEDIO — Alerta Preventiva", desc: "Promedio ≥ 6 h y < 14 días laborados, pero registró un descanso puntual ≤ 5 h  O  acumula entre 10 y 14 días consecutivos de servicio." },
            { color: "low",    emoji: "🟢", label: "RIESGO BAJO — Óptimo",             desc: "Descanso promedio ≥ 6 h, ninguna jornada por debajo de 6 h y menos de 10 días continuos de trabajo." },
        ],
    },
];

const MonitorFatiga = ()=>{
    const [data, setData] = useState(null)
    const [loading, setLoading] = useState([])
    const [openInfo, setOpenInfo] = useState(false)

    useEffect(()=>{
        setLoading(true)
        getData()
    },[])

    const getData = async()=>{
        const data = await getFatigueMonitor().then((res)=>{
        setData(res)
        setLoading(false)
        })
        .catch((err)=>{
            console.log("error getData", err)
            setLoading(false)
        })
    }
    
    return(
        <div className="MonitorFatiga">
            <div className="MonitorFatiga-header">
                <Button
                    icon="info"
                    variant="ghost"
                    onClick={() => setOpenInfo(true)}
                    aria-label="Ver información del módulo"
                >
                    ¿Cómo funciona este módulo?
                </Button>
            </div>

            <CardsPanel data={data} loading={loading}></CardsPanel>
            <Graficas loading={loading} data={data}></Graficas>
            <TableMF data={data} loading={loading}></TableMF>

            <SidePanel
                open={openInfo}
                onClose={() => setOpenInfo(false)}
                title="Monitor de Fatiga"
                subtitle="Diccionario de datos y lógica de cálculo"
                icon="analytics"
                width="500px"
            >
                <div className="mf-info-panel">
                    <div className="mf-info-purpose">
                        <span className="mf-purpose-icon material-icons">psychology</span>
                        <Text size="small">
                            Evalúa el riesgo de fatiga en operadores de SUMA analizando su volumen de
                            servicios, los <strong>intervalos reales de descanso nocturno</strong> y
                            los <strong>días de actividad</strong>, para que Operaciones y Talento Humano
                            puedan prevenir incidentes viales.
                        </Text>
                    </div>

                    <div className="mf-info-section-label">
                        <span className="material-icons">table_chart</span>
                        Campos del reporte
                    </div>

                    <div className="mf-info-fields">
                        {CAMPOS.map(({ campo, icon, descripcion, calculo, niveles, critical }, idx) => (
                            <div key={campo} className={`mf-info-field${critical ? " mf-info-field--critical" : ""}`}>
                                <div className="mf-field-header">
                                    <span className="mf-field-index">{idx + 1}</span>
                                    <span className="material-icons mf-field-icon">{icon}</span>
                                    <code className="mf-field-name">{campo}</code>
                                </div>
                                <Text size="small" className="mf-field-desc">{descripcion}</Text>
                                {calculo && (
                                    <div className="mf-field-calc">
                                        <span className="mf-calc-label">Cálculo</span>
                                        <code className="mf-calc-code">{calculo}</code>
                                    </div>
                                )}
                                {niveles && (
                                    <div className="mf-niveles">
                                        {niveles.map(n => (
                                            <div key={n.label} className={`mf-nivel mf-nivel--${n.color}`}>
                                                <span className="mf-nivel-emoji">{n.emoji}</span>
                                                <div>
                                                    <strong>{n.label}</strong>
                                                    <span>{n.desc}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </SidePanel>
        </div>
    )
}
export default MonitorFatiga